import { render } from "./product-nav-icon.vue.js?vue&type=template&id=04f95687!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./product-nav-icon.vue?vue&type=template&id=04f95687"
const script = {}

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__